import React from "react";
import { Sheet, SheetProps } from "@mui/joy";

const ModalSheet: React.FC<SheetProps> = ({ children, sx, ...props }) => {
  return (
    <Sheet
      sx={{
        bgcolor: "#ffffff",
        borderTopLeftRadius: { xs: "20px", md: "12px" },
        borderTopRightRadius: { xs: "20px", md: "12px" },
        borderRadius: { md: "12px" },
        pt: 1,
        px: 1.5,
        width: "100%",
        maxWidth: "500px",
        mx: "auto",
        transition: "height 0.2s ease",
        overflow: "auto",
        ...sx,
      }}
      {...props}
    >
      {children}
    </Sheet>
  );
};

export default ModalSheet;
